import * as tslib_1 from "tslib";
import { DiffuseBasicMethod } from "./DiffuseBasicMethod";
/**
 * DiffuseWrapMethod is an alternative to DiffuseBasicMethod in which the light is allowed to be "wrapped around" the normally dark area, to some extent.
 * It can be used as a crude approximation to Oren-Nayar or simple subsurface scattering.
 */
var DiffuseWrapMethod = (function (_super) {
    tslib_1.__extends(DiffuseWrapMethod, _super);
    /**
     * Creates a new DiffuseWrapMethod object.
     * @param wrapFactor A factor to indicate the amount by which the light is allowed to wrap
     */
    function DiffuseWrapMethod(wrapFactor) {
        if (wrapFactor === void 0) { wrapFactor = .5; }
        var _this = _super.call(this) || this;
        _this.wrapFactor = wrapFactor;
        return _this;
    }
    Object.defineProperty(DiffuseWrapMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return DiffuseWrapMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DiffuseWrapMethod.prototype, "wrapFactor", {
        /**
         * A factor to indicate the amount by which the light is allowed to wrap.
         */
        get: function () {
            return this._wrapFactor;
        },
        set: function (value) {
            this._wrapFactor = value;
            this._wrapFactor = 1 / (value + 1);
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    return DiffuseWrapMethod;
}(DiffuseBasicMethod));
export { DiffuseWrapMethod };
DiffuseWrapMethod.assetType = "[asset DiffuseWrapMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/DiffuseWrapMethod.js